import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "status",
})
export class StatusPipe implements PipeTransform {
  private statuslist = {
    acceptState: {
      0: "To be confirmed",
      1: "Agree",
      2: "Refuse",
    },
    applyStatus: {
      0: "No",
      1: "Yes",
    },
    eventType: {
      0: "Course",
      1: "Activity",
    },
    joinStatus: {
      0: "Not involved",
      1: "Already participated",
    },
    invite: {
      0: "Sign up by yourself",
      1: "Friend invitation",
    },
    taskType: {
      JOIN_ACTIVITIES: "Join Activities",
      INVITE_MEMBERS: "Invite Members",
      DIRECT_INTRODUCTION: "Direct Introduction",
    },
    activityType: {
      COMMON: "Common",
      PRODUCT: "Product",
    },
    paramsType: {
      1: "Target income",
      2: "Occupation category",
      3: "Health status",
    },
  };

  transform(value: any, args?: any): any {
    return this.statuslist[args][value];
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/pipe/status.pipe.ts